/*
 *******************************************************************************
 *
 *  Filename:   @/pages/renderers/FullName.js
 *
 *  Syntax:     renderCell: (params) => <FullName value={params.value} />
 *
 *  Synopsis:   Use this component to display full name.
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Friday, August 18, 2023 - 6:07 AM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2023/08/18  NJN Initial Build
 *
 *
 *  Copyright (c) 2023 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from "react";

const FullName = (props) => {
  const row = props.data;

  const fullname = row.LASTNAME + ", " + row.FIRSTNAME + " " + (row.MIDDLENAME ? row.MIDDLENAME[0] : "");
  return (
    <div>
      <span>{fullname}</span>
    </div>
  );
};

export default FullName;
